/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Step_PurchaseInputs */

const vi_order_lot_trace_step_purchase = /** @type {(inputs: Order_Lot_Trace_Step_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô mua`)
};

/**

* @param {Order_Lot_Trace_Step_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_step_purchase = /** @type {((inputs?: Order_Lot_Trace_Step_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Step_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_step_purchase(inputs)
});